// We need redux immutable in v5
import { combineReducers } from 'redux-immutable';
import productsV1 from '@americanexpress/product-ducks';
import { resourcesReducer } from 'iguazu-rest';
import { proceduresReducer } from 'iguazu-rpc';
import products from 'axp-product-ducks';
import { fromJS } from 'immutable';
import { name } from '../package.json';
import composeReducers from './utils/composeReducers';

export const SET_UPDATE_DDL_VIEW = `modules/${name}/SET_UPDATE_DDL_VIEW`;
export const UPDATE_INAUTH_UUID = `modules/${name}/UPDATE_INAUTH_UUID`;

export const buildInitialState = (data = {}) => {
  const query = data?.req?.query || {};
  const body = data?.req?.body || {};
  return fromJS({ query, body });
};

export function appParamReducer(state = buildInitialState(), action = {}) {
  switch (action.type) {
    case SET_UPDATE_DDL_VIEW: {
      return state.merge({ updateViewData: action.payload });
    }
    case UPDATE_INAUTH_UUID: {
      return state.merge({ inAuthUUID: action.payload });
    }
    default:
      return state;
  }
}

export function bodyReducer(state = buildInitialState(), action = {}) {
  switch (action.type) {
    default:
      return state;
  }
}

export const reducer = combineReducers({
  query: appParamReducer,
  body: bodyReducer,
  resources: resourcesReducer,
  procedures: proceduresReducer,
  products: composeReducers(products, productsV1),
});

reducer.buildInitialState = buildInitialState;

function setUpdateViewDDL(updateViewData) {
  return { type: SET_UPDATE_DDL_VIEW, payload: updateViewData };
}

function setInAuthUUID(uuid) {
  return { type: UPDATE_INAUTH_UUID, payload: uuid };
}

export const mapDispatchToProps = (dispatch) => ({
  actSetUpdateViewDDL: (...args) => dispatch(setUpdateViewDDL(...args)),
  actSetInAuthUUID: (...args) => dispatch(setInAuthUUID(...args)),
});

export default reducer;
